import { Lookup, LookupItem } from "@data-types";
import { EstimatedGamingAmountDataType } from "@data-types/membership/registration";
import { httpClient, getApplicationHeaders, retryRequest } from "@utils";

class PlatformEstimatedGamingAmountsApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/estimated-gaming-amounts`;
	}

	static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findEstimatedGamingAmount(): Promise<
		Lookup<EstimatedGamingAmountDataType>
	> {
		const response = await retryRequest(() =>
			httpClient.get(`${this.baseUrl}`, this.getRequestHeaders(), {
				responseType: "json",
			})
		);

		return response;
	}
}

export default PlatformEstimatedGamingAmountsApiService;
